import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCompanyDetailFind = createAsyncThunk(
  "fetchCompanyDetailFind",
  async ({ id }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };

    const response = await axiosHttp.get(
      `company/detail/${id}`,
      config
    );
    return response.data.data;
  }
);

const companyDetailFindSlice = createSlice({
  name: "companyDetailFind",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
 
  reducers: {
    resetStateCompanyDetailFind: (state) => {
      state.isLoading = false;
      state.error = null;
      state.data = null;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(fetchCompanyDetailFind.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchCompanyDetailFind.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;

    });
    builder.addCase(fetchCompanyDetailFind.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { resetStateCompanyDetailFind } = companyDetailFindSlice.actions;
export default companyDetailFindSlice.reducer;